export const actionNamespace = 'ssm-web-app';



// WEBPACK FOOTER //
// ./src/state/defaults.js